import React from 'react'
import PropTypes from 'prop-types'
import Logo from '../../../components/Logo'

export default function Header(props) {
	return (
		<header>
			<div className="content-wrap">
				<Logo />
			</div>
			{props.children}
			<div className="arrowBox">
				<div className="arrow"></div>
			</div>
		</header>
	)
}

Header.propTypes = {
	name: PropTypes.string,
	children: PropTypes.element
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/Header.js